import { render, staticRenderFns } from "./QuestionnaireEdit.vue?vue&type=template&id=2f97550f"
import script from "./QuestionnaireEdit.vue?vue&type=script&lang=js"
export * from "./QuestionnaireEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports